import { render } from "./Header.vue?vue&type=template&id=90200e4a&bindings={}"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"
script.render = render

export default script